var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDustbin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.875 1.5H6.6875L6.0625 0.875H2.9375L2.3125 1.5H0.125V2.75H8.875M0.75 10.875C0.75 11.2065 0.881696 11.5245 1.11612 11.7589C1.35054 11.9933 1.66848 12.125 2 12.125H7C7.33152 12.125 7.64946 11.9933 7.88388 11.7589C8.1183 11.5245 8.25 11.2065 8.25 10.875V3.375H0.75V10.875Z",
    fill: "#E94D51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDustbin);
export default __webpack_public_path__ + "static/media/dustbin.224cb8c7b449b48cc759538fa49c8a05.svg";
export { ForwardRef as ReactComponent };